<div class="dialog-overlay" (click)="$event.stopPropagation()">
  <div class="dialog-container">
    <div class="dialog-header">
      <div class="dialog-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h2 class="dialog-title">Session Expired</h2>
    </div>
    
    <div class="dialog-content">
      <p class="dialog-message">Your session has expired due to inactivity. Please sign in again to continue.</p>
    </div>
    
    <div class="dialog-actions">
      <button class="dialog-button primary" (click)="onOkClick()">
        OK
      </button>
    </div>
  </div>
</div>

